import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=bc6b9b12&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc6b9b12')) {
      api.createRecord('bc6b9b12', component.options)
    } else {
      api.reload('bc6b9b12', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=bc6b9b12&", function () {
      api.rerender('bc6b9b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/Users.vue"
export default component.exports